import React, { useEffect, useState } from "react";
import { useAdminOrderStore } from "../../../hooks/admin/order";
import orderinsiteuser from "src/assets/images/order-insite-user.svg";
import orderinsitebilling from "src/assets/images/order-insite-billing.svg";
import orderinsiteshipping from "src/assets/images/order-insite-shipping.svg";
import orderinsiteshippingmethod from "src/assets/images/order-insite-shipping-method.svg";
import companyIcon from "src/assets/images/company-icon.svg";
import System from "../../../helper/system";
import Constants from "../../../helper/Constants";
import Helper from "../../../helper/Helper";
import { __remove, __set } from "../../../store/axios_indicator";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useDOMAttachToSystemStore } from "src/hooks/domAttachToSystem";
import ShowAlert from "src/component/Global/ShowAlert";
import useReduxState from "src/hooks/useReduxState";
import AdminConfig from "@system/config/admin";

const OrderInsightInfo = () => {
  const [{ orderInsightInfo }, { get_admin_order_insight_info }, { reprocess_order }] = useAdminOrderStore();
  const [{ }, { system_alert_indicator,remove_system_alert_indicator }, { }] = useDOMAttachToSystemStore();
  const { paymentType, adminOrderEditEligibleStatus, purchaseOrderNumberPattern } = Constants;
  const [__check] = useAxiosIndicatorCheck();
  const urlParams = System.getParams();
  const [isEditPONumber, setIsEditPONumber] = useState(false);
  const [updateOrderDetail, setUpdateOrderDetail] = useReduxState({ poNumber: '', billingAddress: {}, shippingAddress: {}, comment: '', erpPartNumbers: [], orderNumber: '' }, "updateAdminOrderDetails");
  const [error, setError] = useState('');
  const [saveButtonDisable, setSaveButtonDisable] = useReduxState(true, "saveButtonDisable");
  const editButtonEnable = adminOrderEditEligibleStatus?.includes(updateOrderDetail.FSPOrderStatus)

  useEffect(() => {
    setUpdateOrderDetail({
      poNumber: orderInsightInfo?.poNumber,
      billingAddress: {
        ...orderInsightInfo?.billingAddress,
        companyName: orderInsightInfo?.billingAddress?.companyName?.trim() || ''
      },
      shippingAddress: {
        ...orderInsightInfo?.shippingAddress,
        companyName: orderInsightInfo?.shippingAddress?.companyName?.trim() || ''
      },
      orderNumber: orderInsightInfo?.webOrderNumber,
      FSPOrderStatus: orderInsightInfo?.fspOrderState
    });
  }, [orderInsightInfo]);



  const [originalPONumber, setOriginalPONumber] = useState(updateOrderDetail.poNumber);

  const handleEdit = () => {
    setOriginalPONumber(updateOrderDetail.poNumber);
    setIsEditPONumber(true);
  };

  const handleCancel = () => {
    setUpdateOrderDetail({ ...updateOrderDetail, poNumber: originalPONumber });
    setIsEditPONumber(false);
    setError('');
  };

  const handleSave = () => {
    const poNumber = updateOrderDetail.poNumber.trim();

    if (!poNumber) {
      setError('P.O. Number cannot be empty');
      return;
    }

    if (!Helper.validateRegex(poNumber, purchaseOrderNumberPattern) || poNumber.length > 35) {
      setError("A valid purchase order number is required.");
      return;
    }

    setError('');
    setOriginalPONumber(poNumber);
    setUpdateOrderDetail({ ...updateOrderDetail, isPoNumberEdited: true });
    setIsEditPONumber(false);
    setSaveButtonDisable(false);
  };


  useEffect(() => {
    async function fetchHere() {
      const res = await get_admin_order_insight_info(urlParams);
      if (res?.payload?.Message) {
        system_alert_indicator({
          name: "accessDenied",
          message: res?.payload?.Message,
          type: "danger",
          isDisplayIcon: true,
          isDisplay: false
        });
      }
    }

    fetchHere();
  }, []);

  const onReprocess = async (e) => {
    __set("ORDER_REPROCESS")
    const res = await reprocess_order(urlParams);
    if (!res?.isSuccessFull) {
      await system_alert_indicator({
        name: "reprocessOrder",
        message: res?.errorMessage,
        type: "danger",
        isDisplay: true,
      });
    }

    await get_admin_order_insight_info(urlParams);
    __remove("ORDER_REPROCESS")
  }

  const onSave = () => {
    if (updateOrderDetail.isErpPartNumbersEdited) {
      const hasEmpty = updateOrderDetail.erpPartNumbers.some(e => e?.newValue == null || e?.newValue?.trim() === '');

      if (hasEmpty) {
        system_alert_indicator({
          name: "erpNullMessage",
          message: 'ERP Part Number is required.',
          type: "danger",
          isDisplay: true,
        })
        return;
      }
    }
    remove_system_alert_indicator("erpNullMessage")

    System.popup('OrderAdminCommentPopup', {});
  }


  return <>
    <div className="container">
      <div className="adminconsole-head header-container d-flex align-items-center justify-content-between">
        <div className="page-title font-oswald font-light font-38 text-green cursor-pointer d-flex" onClick={() => window.location.href = AdminConfig.getAdminOrderURL()}>Admin Console</div>
        <button className="btn btn-primary bs5 w150 ms-3" onClick={() => System.popup('OrderAuditLogPopup', {})}>Audit Log</button>
      </div>
      <div className="pcn-line-divider"></div>
      <div className="page-title font-oswald font-light font-30 d-flex">ORDER INSIGHTS
        {__check("ORDER_REPROCESS").status ? __check("ORDER_REPROCESS").render :
          <div className="ms-auto">
            <button className="btn btn-secondary bs5 w150" disabled={saveButtonDisable} onClick={() => onSave()}>Save</button>
            <button className="btn btn-secondary bs5 w150 ms-3" onClick={() => window.location.reload()}>REFRESH</button>
            <button className="btn btn-primary bs5 w150 ms-3" disabled={!orderInsightInfo?.isReprocessable} onClick={onReprocess}>reprocess</button>
          </div>}
      </div>
      <div className='bom-alert'>
        <ShowAlert onlyShowMessage={['adminconsole', 'AdminOrderError', 'reprocessOrder', 'accessDenied', 'erpNullMessage']} />
      </div>
    </div>
    <div className="userdetails bg-gray3 order-insite-container">
      <div className="bg-white pt-3 pb-3">
        <div className="container">
          <div className="font-18 font-apecru mb-4">Order Information</div>
          <div className="order-insite-list">
            <div className="font-arial font-13 position-relative">
              <strong>P.O. Number </strong>
              <button disabled={!editButtonEnable} onClick={handleEdit} className="ms-1 button-icon">
                <i className="fa fa-pencil font-15"></i>
              </button>
              <p className="mb-0">
                {!isEditPONumber ? (
                  <>
                    {updateOrderDetail.poNumber}
                  </>
                ) : (
                  <div className="mt-2 edit-orderinfo">
                    <input
                      type="text"
                      className={`form-control form-control-sm me-1 ${error ? 'is-invalid' : ''}`}
                      placeholder="Enter P.O. Number"
                      value={updateOrderDetail.poNumber}
                      onChange={(e) => setUpdateOrderDetail({ ...updateOrderDetail, poNumber: e.target.value })}
                      maxLength={35}
                    />
                    <div className="d-flex align-items-start edit-orderinfo-btn">
                      <button className="btn-link text-blue2" onClick={handleCancel}>
                        Cancel
                      </button>
                      |
                      <button className="btn-link text-blue2" onClick={handleSave}>
                        Save
                      </button>
                    </div>
                    {error && <div className="invalid-feedback d-block">{error}</div>}
                  </div>
                )}
              </p>
            </div>
            <div className="font-arial font-13">
              <strong>Web Order Number </strong>
              <p className="mb-0">{orderInsightInfo?.webOrderNumber}</p>
            </div>
            <div className="font-arial font-13">
              <strong>Sales Order Number </strong>
              <p className="mb-0">{orderInsightInfo?.salesOrderNumber}</p>
            </div>
            <div className="font-arial font-13">
              <strong>Internal Order State</strong>
              <p className="mb-0">{orderInsightInfo?.fspOrderState}</p>
            </div>
            <div className="font-arial font-13">
              <strong>Reject Reason</strong>
              <p className="mb-0">{orderInsightInfo?.rejectedReason}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-grey2 pt-3 pb-3 order-insite-secondrow">
        <div className="container">
          <div className="order-insite-list">
            <div className="font-arial font-13">
              <div className="d-flex align-items-center font-arial font-16 mb-2">
                <img src={orderinsiteuser} className="me-2" />
                <strong> Buyer Contact Information</strong>
              </div>
              <p className="mb-0 font-arial font-13">
                <div>{orderInsightInfo?.buyerContact?.buyerName} </div>
                <div>{orderInsightInfo?.buyerContact?.buyerEmail}</div>
                <div>{orderInsightInfo?.buyerContact?.buyerTelphoneNumber}</div></p>
            </div>

            <div className="font-arial font-13">
              <div className="d-flex align-items-center font-arial font-16 mb-2">
                <img src={orderinsitebilling} className="me-2" />
                <strong> Billing Address</strong>
                <button disabled={!editButtonEnable || orderInsightInfo?.paymentInfo?.accountNumber} className="ms-2 button-icon">
                  <i onClick={() => System.popup('billingShippingPopup', { addressInfo: updateOrderDetail?.billingAddress, type: "Billing" })} className="fa fa-pencil font-15"></i>
                </button>
              </div>
              <p className="mb-0 font-arial font-13">
                <div>{updateOrderDetail?.billingAddress?.companyName}</div>
                <div>{updateOrderDetail?.billingAddress?.lineOne}</div>
                <div>{updateOrderDetail?.billingAddress?.lineTwo}</div>
                <div>{updateOrderDetail?.billingAddress?.lineThree}</div>
                {updateOrderDetail?.billingAddress?.cityName}, {updateOrderDetail?.billingAddress?.stateName} {updateOrderDetail?.billingAddress?.postalCode}<br />
                {updateOrderDetail?.billingAddress?.countryName}<br />
                {updateOrderDetail?.billingAddress?.countrySubDivisionCode}<br />
              </p>
            </div>

            <div className="font-arial font-13">
              <div className="d-flex align-items-center font-arial font-16 mb-2">
                <img src={orderinsiteshipping} className="me-2" />
                <strong>Shipping Address</strong>
                <button disabled={!editButtonEnable || orderInsightInfo?.paymentInfo?.accountNumber} className="ms-2 button-icon">
                  <i onClick={() => System.popup('billingShippingPopup', { addressInfo: updateOrderDetail?.shippingAddress, type: "Shipping" })} className="fa fa-pencil font-15"></i>
                </button>
              </div>
              <p className="mb-0 font-arial font-13">
                <div>{updateOrderDetail?.shippingAddress?.companyName} </div>
                <div>{updateOrderDetail?.shippingAddress?.lineOne} </div>
                <div>{updateOrderDetail?.shippingAddress?.lineTwo} </div>
                <div>{updateOrderDetail?.shippingAddress?.lineThree} </div>
                {updateOrderDetail?.shippingAddress?.cityName}, {updateOrderDetail?.shippingAddress?.stateName} {updateOrderDetail?.shippingAddress?.postalCode} <br />
                {updateOrderDetail?.shippingAddress?.countryName} <br />
                {updateOrderDetail?.shippingAddress?.countrySubDivisionCode}
              </p>
            </div>

            <div className="font-arial font-13">
              <div className="d-flex align-items-center font-arial font-16 mb-2">
                <img src={orderinsiteshippingmethod} className="me-2" />
                <strong>Shipping Method</strong>
              </div>
              <p className="mb-0 font-arial font-13">
                {orderInsightInfo?.carrierInfo?.carrierKey} <br />
                {orderInsightInfo?.carrierInfo?.carrierService} </p>
            </div>
            <div className="font-arial font-13">
              <div className="d-flex align-items-center font-arial font-16 mb-2">
                <img src={companyIcon} className="me-2" />
                <strong>Company Name</strong>
              </div>
              <p className="mb-0 font-arial font-13">
                {orderInsightInfo?.buyerContact?.companyName} </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white pt-3 pb-3">
        <div className="container">
          <div className="order-insite-list">
            <div className="font-arial font-13">
              <div className="d-flex align-items-center font-arial font-16 mb-2">
                <strong> Payment Method </strong>
              </div>

              <div className="d-flex">
                <div className="me-4">
                  <div className="font-arial font-13">
                    {orderInsightInfo?.paymentInfo?.paymentType === paymentType.CreditCard && <strong>  Credit Card </strong>}
                    {orderInsightInfo?.paymentInfo?.paymentType === paymentType.AvnetCredit && <strong>  Avnet Credit Line </strong>}
                  </div>
                  <div className="d-flex align-items-center font-arial font-13 mb-3">
                    <span>
                      <span dangerouslySetInnerHTML={{ __html: Helper.getCreditCardDetails(orderInsightInfo?.paymentInfo?.cardType?.toLowerCase())?.icon }} />
                      <span className='font-13 font-arial ms-2'>{Helper.getCreditCardDetails(orderInsightInfo?.paymentInfo?.cardType?.toLowerCase())?.name}</span>
                    </span>
                  </div>
                  <p className="mb-0 font-arial font-13">
                    <strong> Tax Exempt </strong> <br />
                    {orderInsightInfo?.paymentInfo?.taxExempt}</p>
                </div>
                <div>
                  <p className="mb-0 font-arial font-13">
                    <strong> Terms Account<br />Information </strong> <br />
                    {orderInsightInfo?.paymentInfo?.accountNumber}</p>
                </div>
              </div>
            </div>

            <div className="font-arial font-13">
              <div className="d-flex align-items-center font-arial font-16 mb-2">
                <strong> Additional Information </strong>
              </div>
              <p className="mb-0 font-arial font-13">
                <strong> Order Date</strong> <br />
                {Helper.dateFormatFromString(orderInsightInfo?.orderDate)}</p>
            </div>

          </div>
        </div>
      </div>

    </div>

  </>;
}

export default OrderInsightInfo;